import React from 'react';
import SubmitAndCancelButton from '../../button/SubmitAndCancelButton';
import EditAndDeleteButton from '../../button/EditAndDeleteButton';
import '../../../styles/Table.css';

interface HasId {
  id: number;
}

interface SingleAddTableBodyProps<T extends HasId> {
  items: T[];
  renderItem: (item: T) => React.JSX.Element;
  addItem?: () => React.JSX.Element;
  isAdding?: boolean;
  setIsAdding?: React.Dispatch<React.SetStateAction<boolean>>;
  editItem: () => React.JSX.Element;
  editingId: number | null;
}

const SingleAddTableBody = <T extends HasId>({
  items,
  renderItem,
  addItem,
  editItem,
  editingId,
  isAdding,
}: SingleAddTableBodyProps<T>) => {
  return (
    <tbody>
      {isAdding && addItem && <tr>{addItem()}</tr>}
      {items?.length > 0 &&
        items.map((item: T) => (
          <tr key={item.id}>
            {editingId === item.id ? editItem() : renderItem(item)}
          </tr>
        ))}
    </tbody>
  );
};

export default SingleAddTableBody;
